import React from 'react';
import { ConfirmationDialogProps, ConfirmationModalTypes } from 'components/Shared/shared.types';

export type BuildLaunchConfirmationDialogParams = {
  showContextFilesLaunchModal: boolean;
  isAudienceEmpty: boolean;
  hasLocalizationWarning: boolean;
  icon: React.ReactElement;
  languageBannerIcon: React.ReactElement;
};

export const buildLaunchConfirmationDialogProps = (
  params: BuildLaunchConfirmationDialogParams,
): ConfirmationDialogProps => {
  const {
    showContextFilesLaunchModal,
    isAudienceEmpty,
    hasLocalizationWarning,
    icon,
    languageBannerIcon,
  } = params;

  const confirmationDialogProps: ConfirmationDialogProps = showContextFilesLaunchModal
    ? {
        theme: ConfirmationModalTypes.LAUNCH,
        className: 'confirmation-modal--almost-done',
        icon,
        title: 'Almost Done!',
        description:
          'Congratulations! Once you launch the experience, the final step is to process your Context Data files.',
        primaryAction: {
          value: 'Launch & view files to process',
        },
        secondaryAction: {
          value: 'Cancel',
        },
        useSecondaryLinkStyle: true,
      }
    : {
        theme: ConfirmationModalTypes.LAUNCH,
        icon,
        title: 'Launch Experience',
        description: (
          <>
            “Launch” activates this experience for all users. You can <b>deactivate</b> it but <b>not revert to Draft.</b>
          </>
        ),
        primaryAction: {
          value: isAudienceEmpty ? 'Launch to everyone' : 'Launch to target audience',
        },
        secondaryAction: {
          value: 'Cancel',
        },
      };

  if (hasLocalizationWarning) {
    confirmationDialogProps.infoBanner = {
      icon: languageBannerIcon,
      title: 'Incomplete language versioning',
      description: 'The other language version isn’t complete. Do you still want to launch?',
    };
  }

  return confirmationDialogProps;
};
